import Vue from "vue"
import {
  Button,
  Image,
  Toast,
  Overlay,
  NavBar,
  Tabbar, TabbarItem,
  NoticeBar,
  Icon,
  Swipe, SwipeItem,
  Col, Row,
  Tab, Tabs,
  Form, Field,
  RadioGroup, Radio,
  Progress,
  Empty,
  Dialog,
  Grid, GridItem,
  Cell, CellGroup,
  Tag,
  Popup,
  Picker,
  ImagePreview,
  Uploader,
  Loading,
  Badge,
  DatetimePicker,
  ActionSheet,
  Checkbox, CheckboxGroup,
  Rate 
} from "vant"
import 'vant/lib/index.css'

Vue.use(Icon) 
Vue.use(Button)
Vue.use(Image)
Vue.use(Toast)
Vue.use(Overlay)
Vue.use(NavBar)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(NoticeBar)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Col)
Vue.use(Row)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Form)
Vue.use(Field)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Progress)
Vue.use(Empty)
Vue.use(Dialog)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(CellGroup)
Vue.use(Tag)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(ImagePreview)
Vue.use(Uploader)
Vue.use(Loading)
Vue.use(Badge)
Vue.use(DatetimePicker)
Vue.use(ActionSheet)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Rate )
